import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'cc-show-row',
  templateUrl: './show-row.component.html',
  styleUrls: ['./show-row.component.scss']
})
export class ShowRowComponent {
  @Input() expanded: boolean;
  @Output() changed = new EventEmitter();

  toggle() {
    this.changed.next();
  }
}
